import axios from "axios";

export function getFullUrl(url) {
  return axios.get(url, {
    // no baseURL
    withCredentials: false, // tokens not needed here
    headers: { "Content-Type": "application/json" },
  });
}
